const isLocalHost = () => {
  return window.location.hostname === 'localhost';
};

export { isLocalHost };
